/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_View_Top_Up_OptionsInputs */

const en_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get more`)
};

const ar_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على المزيد`)
};

const de_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr holen`)
};

const es_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conseguir más`)
};

const fr_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir plus`)
};

const it_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni di più`)
};

const ja_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと手に入れる`)
};

const ko_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`채우러 가기`)
};

const pt_br_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter mais`)
};

const ru_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить ещё`)
};

const th_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปรับเพิ่ม`)
};

const tr_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla edin`)
};

const zh_cn_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往补充`)
};

const zh_tw_btn_view_top_up_options = /** @type {(inputs: Btn_View_Top_Up_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往補充`)
};

/**
* | output |
* | --- |
* | "Get more" |
*
* @param {Btn_View_Top_Up_OptionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_view_top_up_options = /** @type {((inputs?: Btn_View_Top_Up_OptionsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_View_Top_Up_OptionsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_view_top_up_options(inputs)
	if (locale === "ar") return ar_btn_view_top_up_options(inputs)
	if (locale === "de") return de_btn_view_top_up_options(inputs)
	if (locale === "es") return es_btn_view_top_up_options(inputs)
	if (locale === "fr") return fr_btn_view_top_up_options(inputs)
	if (locale === "it") return it_btn_view_top_up_options(inputs)
	if (locale === "ja") return ja_btn_view_top_up_options(inputs)
	if (locale === "ko") return ko_btn_view_top_up_options(inputs)
	if (locale === "pt_br") return pt_br_btn_view_top_up_options(inputs)
	if (locale === "ru") return ru_btn_view_top_up_options(inputs)
	if (locale === "th") return th_btn_view_top_up_options(inputs)
	if (locale === "tr") return tr_btn_view_top_up_options(inputs)
	if (locale === "zh_cn") return zh_cn_btn_view_top_up_options(inputs)
	return zh_tw_btn_view_top_up_options(inputs)
});